export const DELIVERED_INSTRUMENT_STATUSES = Object.freeze([
  'delivered',
  'delivered_with_certificate',
  'delivered_without_certificate',
  'delivered_not_calibrated',
  'delivered_not_repaired',
  'delivered_repaired',
]);

const DELIVERED_STATUS_SET = new Set(DELIVERED_INSTRUMENT_STATUSES);
const CLOSED_STATUS_SET = new Set([
  'remitted',
  ...DELIVERED_INSTRUMENT_STATUSES,
  'cancelled',
]);

export function isDeliveredInstrumentStatus(status) {
  return DELIVERED_STATUS_SET.has(status);
}

export function isClosedInstrumentStatus(status) {
  return CLOSED_STATUS_SET.has(status);
}

function firstEnteredAt(segments, statuses) {
  for (const segment of segments || []) {
    if (statuses.includes(segment?.status)) return segment.entered_at || null;
  }
  return null;
}

/**
 * Resuelve los hitos finales con evidencia independiente. No presupone que
 * revisión, remito y entrega hayan ocurrido en un orden determinado.
 */
export function resolveInstrumentWorkflowMilestones({
  status,
  reviewedAt,
  departureDate,
  hasCurrentRemito,
  remitoDateOut,
  segments = [],
} = {}) {
  const reviewedStamp = firstEnteredAt(segments, ['reviewed']) || reviewedAt || null;
  const remittedStamp = firstEnteredAt(segments, ['remitted']) || remitoDateOut || null;
  const deliveredStamp = firstEnteredAt(segments, DELIVERED_INSTRUMENT_STATUSES)
    || departureDate
    || null;
  const delivered = isDeliveredInstrumentStatus(status);

  return {
    stamps: {
      revisado: reviewedStamp,
      remito: remittedStamp,
      entregado: deliveredStamp,
    },
    completed: {
      // Para datos antiguos, "reviewed" y "ready_to_remit" son por sí mismos
      // evidencia válida. No se infiere revisión desde "remitted".
      revisado: Boolean(reviewedStamp) || ['reviewed', 'ready_to_remit'].includes(status),
      // Un lookup exitoso en remito_items manda sobre el estado histórico. Si
      // el lookup no estuvo disponible, el estado remitted sirve de respaldo.
      remito: hasCurrentRemito === true
        || delivered
        || (hasCurrentRemito == null && status === 'remitted'),
      entregado: Boolean(deliveredStamp) || delivered,
    },
  };
}
